import React, {FC} from "react"

import {WellnessMedia} from "@irati/types"

import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import BaseSvgIcon from "@irati/ui/src/Icon/customIcons/Base"

interface Props {
  media: WellnessMedia
  color?: string
}

const MediaImportantTags: FC<Props> = ({media, color}) => {
  return (
    <Flex marginTop>
      <BaseSvgIcon viewBox="0 0 30 30" width={14} height={14} fill={color} marginRight>
        <path d={media.category.svgData} />
      </BaseSvgIcon>
      <Label color={color}>{media.category.mediaLabel}</Label>
    </Flex>
  )
}

export default MediaImportantTags
